import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=647119ad"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('647119ad')) {
      api.createRecord('647119ad', component.options)
    } else {
      api.reload('647119ad', component.options)
    }
    module.hot.accept("./Table.vue?vue&type=template&id=647119ad", function () {
      api.rerender('647119ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Table/Table.vue"
export default component.exports